import { render, staticRenderFns } from "./wechatPrivateMessageIndex.vue?vue&type=template&id=cc42e9a4&scoped=true"
import script from "./wechatPrivateMessageIndex.vue?vue&type=script&lang=js"
export * from "./wechatPrivateMessageIndex.vue?vue&type=script&lang=js"
import style0 from "./wechatPrivateMessageIndex.vue?vue&type=style&index=0&id=cc42e9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc42e9a4",
  null
  
)

export default component.exports